import React, { useEffect, useState } from 'react';
import Container from '~/components/container';

import * as St from './styles';
import ContainerFlex from '~/components/containerFlex';
import Input from '~/components/input';
import { MaskTypes } from '~/components/input';
import { FormField, setFormState } from '~/utils/form';
import Button from '~/components/button';
import { IListColumn } from '~/models/listCol';
import { currencyMask } from '~/utils/masks';
import { useHistory } from 'react-router-dom';
import TableList from '~/components/tableList';
import useApi, { ApiMethod } from '~/hooks/useApi';
import ConsultTransactionSearchResponse from '~/services/consult/transaction/search/response';
import Endpoints from '~/services/endpoints';
import ConsultTransactionSearchPayload from '~/services/consult/transaction/search/payload';
import Transacao from '~/models/transacao';
import Loading from '~/components/loading';
import { customerHeader, TYPES_TRANSACTION } from '../model/modelAgreementCard';
import Select from '~/components/select';
import Dialog from '~/components/dialog';
import { icons } from '~/assets';

export interface FormTransaction {
  cpf: FormField;
  numeroCartao: FormField;
  tipoTransacao: { name: string; value: string };
}

const AgreementCard: React.FC = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState<FormTransaction>({
    cpf: { name: 'cpf', value: '' },
    numeroCartao: { name: 'numeroCartao', value: '' },
    tipoTransacao: { name: 'tipoTransacao', value: 'TODOS' },
  });
  const [modalInformative, setModalInformative] = useState({
    isOpen: false,
    message: '',
  });

  const history = useHistory();

  const RequestTransactionsAgreementCard = useApi<ConsultTransactionSearchResponse>(
    Endpoints.consult.searchTransaction.replace('PARAM_QUANTITY', '600'),
    ApiMethod.POST,
    {},
    true,
  );

  function montaTipo(
    tipo: string,
    parcelaAtual: string,
    quantidadeParcelas: string,
  ) {
    if (quantidadeParcelas > '1') {
      return `${tipo} parcelas ${parcelaAtual}/${quantidadeParcelas} `;
    }
    return tipo;
  }

  const goToDetail = (id, aberta) => {
    history.push('/consult/transaction/agreement/detail', {
      cpf: form.cpf,
      numeroCartao: form.numeroCartao,
      idTransacao: id,
      aberta,
    });
  };

  const loadData = () => {
    if (RequestTransactionsAgreementCard?.status !== 200) {
      setList([]);
      return;
    }

    const response = (RequestTransactionsAgreementCard.data as unknown) as Transacao[];

    const newList = [];

    response.forEach((transaction) => {
      const isReversal =
        !!transaction.dataEstorno && transaction.tipo !== 'ESTORNO';
      const item: IListColumn[] = [
        // {
        //   type: 'id',
        //   value: i++,
        //   maxChar: 5,
        // },
        {
          title: 'Local da transação',
          value:
            transaction.tipo === 'PAGAMENTO_FATURA'
              ? transaction.localPagamento
              : transaction.localTransacao.replace(
                  'Transação Digital',
                  'Trans. Digital',
                ),
          textAlign: 'center',
          scratched: isReversal,
          maxChar: 19,
          // textAlign: 'center',
        },
        {
          border: true,
          title: 'Valor da Parcela',
          value: `R$ ${currencyMask(Number(transaction.valorTransacao))}`,
          scratched: isReversal,
          maxChar: 10,
          textAlign: 'center',
        },
        {
          border: true,
          title: 'Valor da compra',
          value: `R$ ${currencyMask(Number(transaction.valorCompra))}`,
          scratched: isReversal,
          maxChar: 10,
          textAlign: 'center',
        },
        {
          border: true,
          title: 'Tipo',
          value: montaTipo(
            transaction.descricao.replace(
              'Transação Digital',
              'Trans. Digital',
            ),
            transaction.parcelaAtual,
            transaction.quantidadeParcelas,
          ),
          maxChar: 30,
          textAlign: 'center',
        },
        {
          border: true,
          title: 'Origem',
          value:
            transaction.origemLimite === 'LIMITE_EXTRA'
              ? 'Saldo Vale-compras'
              : transaction.origemLimite === 'PADRAO'
              ? 'Limite Convênio Multi'
              : ' - ',
          maxChar: 10,
          textAlign: 'center',
        },
        {
          border: true,
          title: 'Fatura',
          value: transaction.aberta === '1' ? 'Aberta' : 'Fechada',
          textAlign: 'center',
          maxChar: 15,
        },
        {
          border: true,
          title: 'Data e hora transação',
          value: `${transaction.dataTransacao.split(' ')[0]} ${
            transaction.horarioTransacao
          }`,
          maxChar: 22,
          textAlign: 'center',
        },
        {
          searchAction:
            transaction.tipo === 'ESTORNO'
              ? null
              : () => goToDetail(transaction.idTransacao, transaction.aberta),
          textAlign: 'center',
          maxChar: 5,
        },
      ];
      newList.push(item);
    });

    setList(newList);
  };

  useEffect(() => {
    loadData();
  }, [RequestTransactionsAgreementCard.loading]);

  const searchTransaction = async () => {
    const payload: ConsultTransactionSearchPayload = {
      cpf: form.cpf.unmasked?.length !== 11 ? null : form.cpf.unmasked,
      numeroCartao:
        form.numeroCartao.unmasked?.length !== 16
          ? null
          : form.numeroCartao.unmasked,
      tipoCartao: 'CONVENIO',
      origemLimite: form.tipoTransacao.value === 'TODOS' ? null : form.tipoTransacao.value,
    };

    const response = await RequestTransactionsAgreementCard.callApi(payload);

    if (response.status >= 300 || response.status < 200) {
      const msg =
        response.mensagem || 'Ocorreu um erro ao buscar as transações.';
      setModalInformative({
        isOpen: true,
        message: msg,
      });
    }
  };

  return (
    <>
      <Loading status={RequestTransactionsAgreementCard.loading} />
      <Dialog
        icon={icons.warning}
        open={modalInformative.isOpen}
        positiveLabel="Entendi"
        positiveAction={() =>
          setModalInformative({ isOpen: false, message: '' })
        }
        message={modalInformative.message}
      />
      <Container>
        <St.BoxCard>
          <ContainerFlex row space>
            <ContainerFlex padding={16}>
              <Input
                label="CPF"
                name={form.cpf.name}
                value={form.cpf.value}
                onChange={(e) => setFormState(e, form, setForm)}
                placeholder="000.000.000-00"
                maxLength={14}
                mask={MaskTypes.CPF}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Input
                label="Número do cartão"
                placeholder="0000.0000.0000.0000"
                maxLength={19}
                mask={MaskTypes.CREDIT_CARD}
                onChange={(e) => setFormState(e, form, setForm)}
                name={form.numeroCartao.name}
                value={form.numeroCartao.value}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Select
                options={TYPES_TRANSACTION}
                label="Tipo transação"
                name={form.tipoTransacao.name}
                value={form.tipoTransacao.value as string}
                onChange={(e) => {
                  setFormState(
                    { target: { name: form.tipoTransacao.name, value: e } },
                    form,
                    setForm,
                  );
                }}
              />
            </ContainerFlex>
            <ContainerFlex padding={16}>
              <Button
                fitContent
                onClick={searchTransaction}
                loading={RequestTransactionsAgreementCard.loading}
                disabled={
                  (String(form.cpf?.value)?.length !== 14 &&
                    String(form.numeroCartao?.value)?.length !== 19) ||
                  RequestTransactionsAgreementCard.loading
                }
              >
                <span>Consultar</span>
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>

        {list.length === 0 && RequestTransactionsAgreementCard.isFetched && (
          <St.BoxCard>
            <ContainerFlex center marginTop={30}>
              <St.TitleCategory>Nenhuma transação encontrada.</St.TitleCategory>
            </ContainerFlex>
          </St.BoxCard>
        )}

        {list.length > 0 && (
          <St.BoxCard>
            <ContainerFlex>
              <TableList customerHeader={customerHeader} list={list} />
            </ContainerFlex>
          </St.BoxCard>
        )}
      </Container>
    </>
  );
};

export default AgreementCard;
